import { store } from "..";
// color: action.payload.color,
// icon: action.payload.icon,
// header: action.payload.header,
// body: action.payload.body
export const newfeedback = params => {
  return {
    type: "New Feedback",
    payload: params
  };
};
export const killfeedback = () => {
  return {
    type: "Kill Feedback"
  };
};



// WEBPACK FOOTER //
// ./src/actions/feedback.js